import { useEffect, useRef } from 'react';
import { useUser } from '@clerk/clerk-react';
import { SendUserSignupToN8n } from '../api';

// This component listens for authentication events globally
const AuthListener = () => {
  const { user, isSignedIn } = useUser();
  const previousSignedIn = useRef(false);

  useEffect(() => {
    // Only trigger when user CHANGES from signed out to signed in
    const wasSignedOut = !previousSignedIn.current;
    const isNowSignedIn = isSignedIn;
    
    // Update the ref for next time
    previousSignedIn.current = isSignedIn;

    // Only proceed if user just signed in (state changed from false to true)
    if (!wasSignedOut || !isNowSignedIn || !user) {
      return;
    }

    const handleUserAuth = async () => {
      const userId = user.id;
      const email = user.emailAddresses[0]?.emailAddress;
      
      if (!email) {
        console.log('No email found for user');
        return;
      }

      // Check if this user has ever signed up before
      const hasSignedUpBefore = localStorage.getItem(`n8n_signup_sent_${userId}`);
      
      // Determine if this is a signup or signin
      let eventType;
      if (!hasSignedUpBefore) {
        // First time user - this is a SIGNUP
        eventType = 'signup';
        localStorage.setItem(`n8n_signup_sent_${userId}`, 'true');
      } else {
        // Returning user - this is a SIGNIN
        eventType = 'signin';
      }

      // Prepare data to send
      const userData = {
        email,
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        userId: userId,
        eventType: eventType,
        timestamp: new Date().toISOString(),
        source: 'GemAI App',
      };

      try {
        if (eventType === 'signup') {
          console.log('🆕 NEW USER SIGNUP - Sending to n8n:', userData);
        } else {
          console.log('🔐 USER SIGN IN - Sending to n8n:', userData);
        }

        // Send to n8n
        await SendUserSignupToN8n(userData);
        console.log('✅ User event sent to n8n successfully');

      } catch (error) {
        console.error('❌ Error sending auth data to n8n:', error);
        console.error('Error details:', error.response?.data || error.message);
      }
    };

    // Small delay to ensure user data is fully loaded
    const timer = setTimeout(handleUserAuth, 500);
    
    return () => clearTimeout(timer);
  }, [isSignedIn, user]);

  // This component doesn't render anything
  return null;
};

export default AuthListener;

